import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "../../FirebaseConfig";



const ProductCard = ({ data }) => {
  const isDiscounted = data.prices.productDiscount > 0;
  const isInStock = data.stock > 0;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleProduct = () => {
    navigate(`/product/${data.id}`);
  };


  const showCustomToast = (message) => {
    toast.custom(
      (t) => (
        <div
          className={`${
            t.visible ? "animate-fadeIn" : "animate-fadeOut"
          } bg-white shadow-xl text-black p-4 md:p-6 rounded-lg fixed top-1/2 left-1/2 
          transform -translate-x-1/2 -translate-y-1/2 z-50 
          w-full max-w-sm md:max-w-md lg:max-w-lg text-center`}
        >
          <p className="text-sm md:text-base lg:text-lg font-semibold">{message}</p>
        </div>
      ),
      { duration: 3000 }
    );
  };

  


  const handleAddToCart = async (product,id) => {
    if (!auth.currentUser) {
      toast.error("Please log in to add items to your cart.");
      // alert("Please log in to add items to your cart.");
      // navigate(`/login?redirect=/`);
      return;
    }

    if ( product.stock<1) return;

    // setAddingToCart(true);
    const userId = auth.currentUser.uid;
    const cartRef = doc(firestore, "customers", userId);
    toast.loading("Adding Item .!");

    try {
      const cartSnap = await getDoc(cartRef);

      if (cartSnap.exists()) {
        const cartData = cartSnap.data();
        let updatedCart = { ...cartData };

        if (updatedCart.items) {
          const existingItemIndex = updatedCart.items.findIndex(item => item.productId === id);

          if (existingItemIndex !== -1) {
            updatedCart.items[existingItemIndex].quantity += 1;
          } else {
            updatedCart.items.push({ productId: id, quantity:1 });
          }
        } else {
          updatedCart = { items: [{ productId: id, quantity:1 }] };
        }

        await updateDoc(cartRef, updatedCart);
      } else {
        await setDoc(cartRef, { items: [{ productId: id, quantity:1 }] });
      }
      toast.dismiss();
      toast.success("Item added to cart!");
    } catch (error) {
      toast.dismiss();

      console.error("Error adding to cart:", error);
      toast.error("Error adding item to cart. Please try again.");
    }

    // setAddingToCart(false);
  };
  return (
    <div
      onClick={handleProduct}
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-transform cursor-pointer w-full max-w-[280px] pb-4"
    >
      {/* Discount Tag */}
      {/* {isDiscounted && (
        <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
          SALE
        </div>
      )} */}

      {/* Product Image with Shimmer Effect */}
      <div className={`relative w-full flex justify-center items-center bg-gray-100 rounded-md ${
        isLoading ? 'h-[200px]' : 'h-auto'}`}>
        {/* Shimmer Effect - Only Visible While Loading */}
        {isLoading && (
          <div className="absolute inset-0 bg-gray-300 animate-pulse rounded-md"></div>
        )}

        {/* Actual Image */}
        <img
          src={data.thumbnail}
          alt={data.name}
          className={`w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
            isLoading ? "opacity-0" : "opacity-100"
          }`}
          onLoad={() => setIsLoading(false)}
          onError={() => setIsLoading(false)} // Fallback in case image fails to load
        />

        {/* Status Badge */}
        {data.status !== "Normal" && (
          <div
            className={`absolute top-2 left-2 px-3 py-1 rounded-full text-xs font-semibold ${
              isInStock ? "bg-red-500 text-white" : "bg-gray-400 text-white"
            }`}
          >
            {isInStock ? data.status : "Out of Stock"}
          </div>
        )}
      </div>

      {/* Product Details */}
      <div className="text-center px-2">
        <h3 className="text-sm font-semibold text-gray-700 truncate">
          {data.name}
        </h3>
        <p className="text-sm text-gray-600">{data.category}</p>

        {/* Price Display */}
        <div className="mt-2 flex items-center justify-center space-x-2">
          {isDiscounted && (
            <span className="text-gray-500 line-through text-sm">
              ₹{data.prices.productPrice}
            </span>
          )}
          <span className="text-orange-500 font-bold text-lg">
            ₹{data.prices.productPrice - data.prices.productDiscount}
          </span>
        </div>

        {/* Add to Cart Button */}
        <button 
  onClick={(e) => {
    e.stopPropagation(); // Prevents navigation when clicking button
    handleAddToCart(data, data.id);
  }} 
  className={`mt-3 px-4 py-2 rounded hover:${data.stock < 1 ? 'bg-gray-500' : 'bg-green-700'} ${data.stock < 1 ? 'bg-gray-600' : 'bg-green-600'} text-white`}
  disabled={data.stock < 1}  // Optionally disable the button if stock is less than 1
>
{data.stock < 1 ? 'Out Of Stock' : 'Add 🍯'}</button>

      </div>
    </div>
  );
};

export default ProductCard;
